@if (isLoading | async) {
  <div class="overlay">
    <img src="../../../../assets/gif/Loader-120.gif" alt="Loader" class="spinner" />
  </div>
}
